import React from "react";

import { Input } from "~/components/input";
import { useScope } from "~/tools/impulse";

import { WidgetDecimals } from "./form-state";

export interface WidgetDecimalsFieldProps {
	className?: string;
	disabled?: boolean;
	name: string;
	decimals: WidgetDecimals;
}

export const WidgetDecimalsField: React.FC<WidgetDecimalsFieldProps> = ({ className, disabled, name, decimals }) => {
	const scope = useScope();

	return (
		<Input
			className={className}
			disabled={disabled}
			max={WidgetDecimals.max}
			min={WidgetDecimals.min}
			name={name}
			onChange={(event) => decimals.setInput(event.target.value)}
			placeholder="Auto"
			type="number"
			value={decimals.getInput(scope)}
		/>
	);
};
